import { apiSlice, baseUrl } from "../../../app/api/apiSlice";

export const ws_url = `${baseUrl.replace("http", "ws")}/ws/stream/{session_id}/`;
export const chatLogsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    v2getChatLogs: builder.query({
      query: (params) => ({
        url: "/api/v2/resources/chatlogs/detailed/",
        params,
      }),
      providesTags: ["ChatLog"],
    }),
    v2fetchChatLogById: builder.query({
      query: (id) => `/api/v2/resources/chatlogs/${id}/`,
      providesTags: (result, error, id) => [{ type: "ChatLog", id }],
    }),
    v2createChatLog: builder.mutation({
      query: (args) => ({
        url: "/api/v2/resources/chatlogs/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["ChatLog"],
    }),
    v2deleteChatLog: builder.mutation({
      query: (id) => ({
        url: `/api/v2/resources/chatlogs/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ChatLog"],
    }),
  }),
});

export const {
  useV2getChatLogsQuery,
  useV2fetchChatLogByIdQuery,
  useV2createChatLogMutation,
  useV2deleteChatLogMutation,
} = chatLogsApiSlice;